export default __webpack_public_path__ + "static/media/addCard.2c33356d.svg";